import { customInstance } from "config/mutator";

import type {
  ClientStrategyCategoryDTO,
  ClientStrategyCategoryDTOStrategyCategory,
  ClientStrategyUpdateRequest,
} from "generated/schemas";

export type ClientStrategyParams = {
  clientId: string;
  strategyCategory: ClientStrategyCategoryDTOStrategyCategory;
};

export type UpsertClientStrategyParams = ClientStrategyParams & {
  data: ClientStrategyUpdateRequest["data"];
};

export const getClientStrategy = ({
  clientId,
  strategyCategory,
}: ClientStrategyParams): Promise<ClientStrategyCategoryDTO> =>
  customInstance<ClientStrategyCategoryDTO>({
    url: `/api/clients/${clientId}/strategy/${strategyCategory}`,
    method: "GET",
  });

export const upsertClientStrategy = ({
  clientId,
  strategyCategory,
  data,
}: UpsertClientStrategyParams): Promise<ClientStrategyCategoryDTO> =>
  customInstance<ClientStrategyCategoryDTO>({
    url: `/api/clients/${clientId}/strategy/${strategyCategory}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: { data },
  });
